import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Empty, Spin } from 'antd'
import { WeaverLoading } from 'Components'
import { WeaverQuery } from 'Services/WeaverUtils'
import TreeView from './TreeView'
import { useTreeData } from './TreeDataProvider'
import { loadRootTreeNodes } from './TreeDataProvider/helpers'
import { setCurrentItem } from 'Actions/explore'
import './TreeViewContainer.scss'
import { QUERY } from 'Types'

TreeViewContainer = ({ data, currentBranch }) ->

  [{ isLoading, rootNodes }, dispatch] = useTreeData()
  [title, setTitle] = useState('')
  [relationsToFollow, setRelationsToFollow] = useState(['*'])

  useEffect(->
    if data.type is QUERY
      { label } = data
      query = data.data.treeQuery or data.data.query
      if typeof query is "string"
        query = Object.assign(
          new WeaverQuery(),
          JSON.parse(query)
        )
      rels = getRelationsToFollow(query)
      setRelationsToFollow(rels)
      loadRootTreeNodes(query, rels, dispatch)
      setTitle(label)
    undefined
  , [data, currentBranch])

  getRelationsToFollow = (q) ->
    toInclude = (q._selectOut
      ?.map((path) -> { key: path[0], orientation: 'OUT' })
      .flat() or []
    ).concat(
      q._selectIn
        ?.map((path) -> { key: path[0], orientation: 'IN' })
        .flat() or []
    ).concat(
      q._selectRecursiveOut
        ?.map((key) -> { key, orientation: 'OUT' })
        .flat() or []
    ).concat(
      q._selectRecursiveIn
        ?.map((key) -> { key, orientation: 'IN' })
        .flat() or []
    )
    toIgnore = (q._selectOutMinus
      ?.map((path) -> { key: path, orientation: 'OUT' })
        .flat() or []
    ).concat(
      q._selectInMinus
        ?.map((path) -> { key: path, orientation: 'IN' })
        .flat() or []
    )

    { toInclude, toIgnore, toExclude: q._excludeNodes }

  <>
    {if isLoading
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <WeaverLoading style={{ width: '20%' }}/>
      </div>
    else if rootNodes[0]
      <>
        <h4 className="tree-title">{ title }</h4>
        <TreeView relationsToFollow={relationsToFollow} />
      </>
    else
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Empty
          description='No Elements'
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </div>
    }
  </>
export default connect(({ explore, branches }) ->
  currentBranch: branches.currentBranch
  data: explore.currentItem
, { setCurrentItem } )(TreeViewContainer)
